import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

/**
 * Convert a URL-safe base64 string to a Uint8Array (for VAPID applicationServerKey).
 */
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Register service worker for PWA + Push Notifications
//
// Ce bloc s'executait au `load`, en concurrence directe avec le premier rendu :
// enregistrement du service worker, appel reseau pour la cle VAPID, demande de
// permission. Il est desormais differe jusqu'a ce que le navigateur soit
// disponible — meme comportement, hors du chemin critique. La resouscription
// n'a lieu que s'il n'y en a pas deja une, au lieu d'etre rejouee a chaque
// chargement.
const whenIdle = (fn) => (
  'requestIdleCallback' in window
    ? window.requestIdleCallback(fn, { timeout: 4000 })
    : setTimeout(fn, 2000)
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => whenIdle(async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('SW registered:', registration.scope);

      // Push notification subscription (never on the camera page: an installed camera app must not ask for notifications)
      if ('PushManager' in window && !window.location.pathname.startsWith('/live-camera')) {
        try {
          const response = await fetch('/api/push/vapid-public-key');
          const { public_key } = await response.json();

          const existing = await registration.pushManager.getSubscription();
          if (public_key && !existing && Notification.permission !== 'denied') {
            const permission = await Notification.requestPermission();
            if (permission === 'granted') {
              const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(public_key)
              });

              await fetch('/api/push/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ subscription: subscription.toJSON() })
              });
              console.log('Push subscription successful');
            }
          }
        } catch (pushErr) {
          console.log('Push subscription failed:', pushErr);
        }
      }
    } catch (error) {
      console.log('SW registration failed:', error);
    }
  }));
}
